import { Box, Hidden, Typography } from '@mui/material';
import React from 'react';
import { Button } from 'tt-ui-lib/core';
import { MessageIcon, OrdersIcon } from 'tt-ui-lib/icons';
import { AppAvatar } from 'components/Avatar';
import styles from '../ListItem.module.scss';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const ListItem = ({ user }) => (
  <Box className={styles.connectItem}>
    <Box className={styles.infoBlock}>
      <AppAvatar
        userName={`${user.first_name} ${user.last_name}`}
        role={user.roles && user.roles[0]?.name}
        src={user.avatar}
        nav={0}
        size="sm"
      />
      <Box className={styles.userInfo}>
        <Box className={styles.userName}> {`${user.first_name} ${user.last_name}`}</Box>
        <Box className={styles.invitedBy}>Invited by {user.inviter}</Box>
        <Box className={styles.experiences}>
          <OrdersIcon style={{ marginRight: 5, width: 14, height: 14 }} />
          <Typography className={styles.experienceName}>
            {user.experiences[0]?.title} of{' '}
            <Typography className={styles.greenText}>
              {user.experiences[0]?.company_name}
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
    <Box className={styles.connectionActions}>
      <Hidden smUp>
        <Button type="link">
          <MoreVertIcon width={4} height={14} sx={{ color: '#18397A' }} />
        </Button>
      </Hidden>
      <Hidden smDown>
        <Button type="icon">
          <img src="/images/templates/heart-icon.svg" alt="" style={{ width: 24, height: 24 }} />
        </Button>
        <Button type="icon">
          <MessageIcon className={styles.itemIcon} />
        </Button>
        <Button type="icon">
          <MoreVertIcon width={4} height={14} sx={{ color: '#18397A' }} />
        </Button>
      </Hidden>
    </Box>
  </Box>
);

export default ListItem;
